/**
 * @author      matthew@zumper.com (Matthew Talamini)
 * @copyright   Copyright (c) 2022, Zumper
 */

import { type Theme, css } from '@emotion/react'

export const amenitiesLine = ({ colors, typography, spacing }: Theme) => css`
  margin-top: ${spacing?.spacing1 ?? '2px'};
  color: ${colors?.textLightest ?? '#726f6c'};
  letter-spacing: -0.2px;
  font-size: ${typography?.fontSize14 ?? '14px'};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`
